import type { LandingCourse } from "../types/landing.types";

const CHECKOUT_SESSION_KEY = "landing_checkout_course";

export interface CheckoutSessionState {
  course: LandingCourse;
  levelId: string;
  classId: string;
  level1Id?: string;
  /** Canonical /classes/{levelname}/ slugs */
  categorySlug?: string;
  courseSlug?: string;
}

export function saveCheckoutSession(state: CheckoutSessionState): void {
  try {
    sessionStorage.setItem(CHECKOUT_SESSION_KEY, JSON.stringify(state));
  } catch {
    // Ignore storage errors (private browsing, quota, etc.)
  }
}

export function loadCheckoutSession(): CheckoutSessionState | null {
  try {
    const raw = sessionStorage.getItem(CHECKOUT_SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CheckoutSessionState;
  } catch {
    return null;
  }
}

export function clearCheckoutSession(): void {
  try {
    sessionStorage.removeItem(CHECKOUT_SESSION_KEY);
  } catch {
    // Ignore storage errors
  }
}

